import { render } from "./Image.vue?vue&type=template&id=aea82982&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=aea82982&scoped=true&lang=css"

import exportComponent from "F:\\物流项目\\新版项目物流项目\\delivery\\Source\\Delivery.Admin.UI\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea82982"]])

export default __exports__